import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW9009Component } from './kymw9009.component';

import { GetUserClassManagementListService } from './api-services/get-user-class-management-list.service';
import { GetOktaInfomationListService } from './api-services/get-okta-infomation-list.service';
import { UpdateUserClassManagementService } from './api-services/update-user-class-management.service';
import { DeleteUserClassManagementService } from './api-services/delete-user-class-management.service';
import { GetOktaUserNameService } from './api-services/get-okta-user-name.service';

/**
 * ユーザ階層管理画面 モジュール設定クラス
 *
 * @export KYMW9009Module
 * @class KYMW9009Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9009Component,
  ],
  providers: [
    GetUserClassManagementListService,
    GetOktaInfomationListService,
    UpdateUserClassManagementService,
    DeleteUserClassManagementService,
    GetOktaUserNameService,
  ],
})
export class KYMW9009Module { }
